module.exports = __webpack_public_path__ + "img/back.211ddade.png";